module.exports = __webpack_public_path__ + "static/media/GRUNDFOS.a74e0d5d.pdf";